import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpStatusCode } from "axios";
import { v4 } from "uuid";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { PostInputSubmissionResponseDto } from "../../../types/dto/chat/send-input-submission-response-dto";
import { PostInputSubmissionRequestDto } from "../../../types/dto/chat/send-input-submission-request-dto";
import { sendMessageLogSubmission } from "./send-message-log";
import VurbalizeEvents from "../../../types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../application/utils/get-message-by-vurablize-event";
import getCommonData from "../../../../application/utils/get-common-data";
import { ChatMessage } from "../types/chat-message";
import { useContext } from "react";
import { ChatContext } from "../../../../application/contexts/chat-context";
import { getChatMessages } from "./get-chat-messages";

export function getConversationSummary(conversation_id: string, messages: ChatMessage[]) {
  const result: {conversation_id: string, itemType: string, value: string, turn_id: string}[] = [];
  messages.forEach((key) => {
    if (key.conversation_id !== conversation_id) return;
    result.push({
      conversation_id: key.conversation_id,
      itemType: key.itemType,
      value: key.value,
      turn_id: key.turn_id,
    })
  });
  return result;
}

export const postCallbackForm =
  createAsyncThunk<void, { formData: Record<string, any> }>(
    "chat-slice/post-callback-form",
    async (
      { formData },
      { getState, signal, rejectWithValue, fulfillWithValue, dispatch }
    ) => {
      const state = getState() as RootState;
      const { sendMessageToServer } = useContext(ChatContext);

      const data: Record<string, any> = getCommonData(state["app-state"]);
      data["form_data"] = formData;
      data["conversation_json"] = getConversationSummary(
        state["app-state"].conversationId,
        state.chat.messages,
      );

      const response = await axiosClient.post('/mail_conversation_summary_for_callback', data, { signal });

      if (response.status !== HttpStatusCode.Ok) {
        // Return the known error for future handling
        return rejectWithValue(response.data);
      }

      if (sendMessageToServer) {
        sendMessageToServer({ message: "Operator:[User has filled the callback form, thank the user]" });
      }
      dispatch(
        sendMessageLogSubmission({
          data: {
            event_name: VurbalizeEvents.CALLBACK_SUBMIT_EVENT,
            message: getMessageByVurablizeEvent(VurbalizeEvents.CALLBACK_SUBMIT_EVENT),
            event_uri: "callback submitted",
            event_payload: {},
            turn_id: v4(),
          },
        })
      );
    }
  );
